import { render, staticRenderFns } from "./QScoreCardQuilityRxCodesUsed.vue?vue&type=template&id=572c40b4&scoped=true&"
import script from "./QScoreCardQuilityRxCodesUsed.vue?vue&type=script&lang=js&"
export * from "./QScoreCardQuilityRxCodesUsed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c40b4",
  null
  
)

export default component.exports